import * as React from "react";
import { CodeEditor, TextFormat } from "~/components/CodeEditor/CodeEditor";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
import { commandLinePackagingInstruction } from "../../Instructions";
import { CommonTextForOctopusCli } from "../CommonRegistrationText";
import styles from "../Registrations.module.less";
const editorText = `# Publish the application to a folder
dotnet publish source/MyApp.Web --output published-app --configuration Release

# Package the folder into a ZIP
octopus package zip create --id MyApp.Web --version 1.0.0 --base-path published-app`;
export const CommandLinePackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging .NET Core applications from command line, we recommend using <code>dotnet publish</code> on the project followed by <code>octopus package (nuget|zip) create</code> using the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>{" "}
            on the output directory.
        </p>
        {CommonTextForOctopusCli}
        <div className={styles.codeContainer}>
            For example:
            <br />
            <CodeEditor value={editorText} onChange={() => undefined} readOnly={true} language={TextFormat.PlainText} showToolbar={true} showCopyButton={true} allowFullScreen={false}/>
        </div>
    </div>);
CommandLinePackaging.displayName = "CommandLinePackaging"
export default commandLinePackagingInstruction(() => <CommandLinePackaging />);
